import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../ui/button';
import {
  Edit, Eye, Trash2, LayoutGrid, Loader2, CheckCircle, AlertCircle, Clock
} from 'lucide-react';

const StatusIcon = ({ status }) => {
  switch (status) {
    case 'generating':
      return <Loader2 className="w-4 h-4 animate-spin text-yellow-500" />;
    case 'generated':
      return <CheckCircle className="w-4 h-4 text-green-500" />;
    case 'published':
      return <CheckCircle className="w-4 h-4 text-[#7dd3fc]" />;
    case 'failed':
      return <AlertCircle className="w-4 h-4 text-red-500" />;
    default:
      return <Clock className="w-4 h-4 text-[#888680]" />;
  }
};

export const ProjectCard = ({ project, onDelete }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-[#302f2c] border border-[#1e3a5f]/50 rounded-lg overflow-hidden hover:border-[#7dd3fc]/30 transition-all group">
      {/* Preview placeholder */}
      <div className="h-40 bg-[#1a1c1b] flex items-center justify-center relative overflow-hidden">
        <LayoutGrid className="w-12 h-12 text-[#1e3a5f]" />
        {project.generated_code?.globalStyles?.primaryColor && (
          <div
            className="absolute bottom-0 left-0 right-0 h-1"
            style={{ backgroundColor: project.generated_code.globalStyles.primaryColor }}
          />
        )}
      </div>

      <div className="p-5">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h3 className="text-[#7dd3fc] font-bold text-lg">{project.name}</h3>
            <p className="text-[#888680] text-sm line-clamp-2">{project.prompt}</p>
          </div>
          <div className="flex items-center gap-1">
            <StatusIcon status={project.status} />
            <span className="text-[#888680] text-xs capitalize">{project.status}</span>
          </div>
        </div>

        <div className="text-[#888680] text-xs mb-4">
          Created {new Date(project.created_at).toLocaleDateString()}
        </div>

        <div className="flex gap-2">
          <Button
            onClick={() => navigate(`/admin/editor/${project.project_id}`)}
            data-testid={`edit-project-${project.project_id}`}
            className="flex-1 bg-[#1e3a5f] text-[#7dd3fc] hover:bg-[#7dd3fc] hover:text-[#1a1c1b] rounded-full py-2 text-sm font-medium flex items-center justify-center gap-1"
          >
            <Edit size={14} />
            Edit
          </Button>
          <Button
            onClick={() => navigate(`/admin/preview/${project.project_id}`)}
            variant="outline"
            data-testid={`preview-project-${project.project_id}`}
            className="border-[#1e3a5f] text-[#888680] hover:text-[#7dd3fc] hover:border-[#7dd3fc]/50 rounded-full py-2 px-3"
          >
            <Eye size={14} />
          </Button>
          <Button
            onClick={() => onDelete(project.project_id)}
            variant="outline"
            data-testid={`delete-project-${project.project_id}`}
            className="border-[#1e3a5f] text-[#888680] hover:text-red-500 hover:border-red-500/50 rounded-full py-2 px-3"
          >
            <Trash2 size={14} />
          </Button>
        </div>
      </div>
    </div>
  );
};
